<template>
  <div class="contact">
    <a-form class="login-form" @submit="handleSubmit">
      <a-form-item>
        <a-row :gutter="8">
          <a-col :span="12">
            <a-input
              @change="handleChange"
              v-model="name"
              name="name"
              placeholder="NAME"
              allow-clear
            />
          </a-col>

          <a-col :span="12">
            <a-input
              v-model="company"
              name="company"
              placeholder="COMPANY"
              allow-clear
            />
          </a-col>
        </a-row>
      </a-form-item>

      <a-form-item>
        <a-row :gutter="8">
          <a-col :span="12">
            <a-input
              v-model="jobTitle"
              name="jobTitle"
              placeholder="Job Title"
              allow-clear
            />
          </a-col>

          <a-col :span="12">
            <a-input
              @change="handleChange"
              name="email"
              v-model="email"
              placeholder="EMAIL"
              allow-clear
            />
          </a-col>
        </a-row>
      </a-form-item>

      <a-row>
        <a-form-item>
          <a-textarea
            :rows="4"
            v-model="message"
            name="message"
            placeholder="LEAVE A MESSAGE"
            allow-clear
          />
        </a-form-item>
      </a-row>
      <input type="hidden" v-model="hiddenValue" name="save" />
      <div class="row">
        <Button @onClick="handleSubmit" className="sendButton">SEND</Button>
      </div>
    </a-form>
  </div>
</template>

<script>
// @ is an alias to /src
import Button from "@/components/Button";
import { GOOGLE_SITE_KEY } from "@/config/google.js";
const KEY = "s&cr&t";

export default {
  name: "Contact",
  components: {
    Button
  },
  data() {
    return {
      sitekey: GOOGLE_SITE_KEY,
      name: "",
      jobTitle: "",
      company: "",
      message: "",
      email: "",
      hiddenValue: ""
    };
  },
  methods: {
    validate(response) {
      console.log(response);
    },
    handleChange(event) {
      if (event.target.name === "name" || event.target.name === "email") {
        if (this.hiddenValue !== KEY) {
          this.hiddenValue = KEY;
        }
      }
    },
    handleSubmit(event) {
      if (event) {
        event.preventDefault();
      }
      const body = {
        name: this.name,
        email: this.email,
        jobTitle: this.jobTitle,
        company: this.company,
        message: this.message
      };

      if (
        Object.values(body).every(val => val !== "") &&
        this.hiddenValue === KEY
      ) {
        console.log(body);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";

.contact {
  align-self: center;
  width: 60%;

  .row {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;

    @media screen and (max-width: $MobileMaxWidth) {
      flex-wrap: wrap;
      justify-content: center;
    }
  }

  .captcha {
    display: inline;
    @media screen and (max-width: $MobileMaxWidth) {
      margin-top: 16px;
    }
  }

  .sendButton {
    width: 240px;
    height: 40px;
    font-size: 16px;
    border-radius: 8px;
  }
}
</style>
